import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LangContext";
import { BOOK_PATH, STEPS, STRINGS, TP_COPY } from "../../data/content";

export default function Steps() {
  const { t } = useLang();
  return (
    <section className="section" style={{ background: "var(--white)" }}>
      <div className="section-inner">
        <div className="fade-in">
          <div className="section-label">{t(STRINGS.processLabel)}</div>
        </div>
        <h2 className="section-title fade-in">{t(STRINGS.processTitle)}</h2>
        <div className="steps">
          {STEPS.map((s) => (
            <div className="step fade-in" key={s.num}>
              <div className="step-num">{s.num}</div>
              <div>
                <div className="step-title">{t(s.title)}</div>
                <div className="step-desc">{t(s.desc)}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="tp-row fade-in">
          <img src="/images/img_8.jpg" alt="TrainingPeaks app" className="tp-img" />
          <div className="tp-copy">
            <div className="tp-copy-label">{STRINGS.trainingPeaks}</div>
            <p className="tp-copy-text">{t(TP_COPY)}</p>
          </div>
        </div>
        <div className="fade-in" style={{ marginTop: 44 }}>
          <Link to={BOOK_PATH} className="btn btn-dark">
            {t(STRINGS.bookCallFree)}
          </Link>
        </div>
      </div>
    </section>
  );
}
